import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import {
    RadioGroup,
    Radio,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@material-ui/core/Box';
import listLiveStreamOrganizer from '../../assets/jss/pages/listLiveStreamOrganizerStyle';
import Validation from '../../common/Validation';
import WrapperContainer from '../../components/Container/WrapperContainer';
import CleanableInput from '../../components/Input/CleanableInput';
import Button from '../../components/Button/CustomButton';
import FormDialog from '../../components/Dialog/FormDialog';
import CustomTypography from '../../components/Typography/CustomTypography';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import Loader from '../../components/Loader/Loader';
import SnackBar from '../../components/Snackbar/Snackbar';
import InputHasUnit from '../SeminarManagementOrganizer/inputHasUnit';
import UploadButton from '../../components/Button/UploadButton';
import AlertDialog from '../../components/Dialog/AlertDialog';
import CustomTextSelector from '../../selectors/CustomText';

const useStyles = makeStyles(listLiveStreamOrganizer);

const DialogEditLiveStreamOrganizer = (props) => {
    const {
        isOpen,
        isLoading,
        updateSuccess,
        eventName,
        detailEvent,
        handleIsClose,
        fetchGetDetailLiveStream,
        updateDetailLiveStream,
        fetchClearDetailLiveStream,
        fetchClearUpdateLiveStream,
        liveStreamId,
        eventInfo,
    } = props;

    const classes = useStyles();
    const intl = useIntl();

    const [validateResults, setValidateResults] = useState({});
    const [params, setParams] = useState({});
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);
    const [messageAction, setMessageAction] = useState('');
    const [checkLimit, setCheckLimit] = useState('1');
    const [checkCost, setCheckCost] = useState('1');
    const [isOpenDialogConfirm, setIsOpenDialogConfirm] = useState(false);
    const [changeDataUpLoad, setChangeDataUpLoad] = useState({ changeDocument: false });
    const [errorsUpload, setErrorUpload] = useState(false);
    const customText = useSelector(CustomTextSelector.createGetCustomText());

    const hasCost = { yes: '1', no: '0' };
    const hasLimit = { yes: '1', no: '0' };

    useEffect(() => {
        fetchClearDetailLiveStream();
        return () => {
            fetchClearDetailLiveStream();
        };
    }, []);

    useEffect(() => {
        if (isOpen) {
            fetchGetDetailLiveStream({ event_name: eventName, live_stream_id: liveStreamId });
        }
    }, [isOpen]);

    useEffect(() => {
        if (detailEvent) {
            setParams({
                ...detailEvent,
                documentPreview: detailEvent.document,
                limit: (+detailEvent.limit === -1 || !+detailEvent.limit) ? 0 : +detailEvent.limit,
            });
            if (!+detailEvent.limit || +detailEvent.limit === -1) {
                setCheckLimit('0');
            } else setCheckLimit('1');
            if (!+detailEvent.cost) {
                setCheckCost('0');
            } else setCheckCost('1');
        }
    }, [detailEvent]);

    useEffect(() => {
        if (updateSuccess) {
            handleIsClose();
            setIsOpenSnackBar(true);
            setMessageAction('ライブ配信を更新しました');
            fetchClearUpdateLiveStream();
        }
    }, [updateSuccess]);

    const handleSetParams = (field, value) => {
        setParams((prevParams) => ({ ...prevParams, [field]: value }));
    };

    const actionsButton = () => (
        <Box style={{ margin: 'auto' }}>
            <Button
                autoFocus
                gradient
                onClick={handleSubmit}
                size="md"
                color="success"
                className={classes.btn}
                style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
            >
                {intl.formatMessage({ id: 'save' })}
            </Button>
            <Button
                autoFocus
                gradient
                onClick={handleCloseDialog}
                size="md"
                color="danger"
                style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
            >
                {intl.formatMessage({ id: 'cancel' })}
            </Button>
        </Box>
    );

    const validate = () => {
        const {
            title_en, speaker_en, inquiry, survey_link, document_link,
        } = params;

        const validateRules = {
            streamer_profile: [
                () => Validation.validateMaxLength(params.streamer_profile, 300),
            ],
            content: [
                () => Validation.isNotEmpty(params.content),
                () => Validation.validateMaxLength(params.content, 300),
            ],
            document_link: [
                () => Validation.validateMaxLength(document_link, 500),
                () => Validation.isValidUrl(document_link),
            ],
            survey_link: [
                () => Validation.validateMaxLength(survey_link, 500),
                () => Validation.isValidUrl(survey_link),
            ],
            inquiry: [() => Validation.validateMaxLength(inquiry, 100),
                () => Validation.validateEmail(inquiry),
            ],
        };

        if (!_.isEmpty(eventInfo.languages)) {
            validateRules.title_en = [
                () => Validation.isNotEmpty(title_en),
                () => Validation.validateLatin(title_en),
                () => Validation.validateMaxLength(title_en, 500),
            ];
            validateRules.speaker_en = [
                () => Validation.isNotEmpty(speaker_en),
                () => Validation.validateLatin(speaker_en),
                () => Validation.validateMaxLength(speaker_en, 255),
            ];
            validateRules.content_en = [
                () => Validation.isNotEmpty(params.content_en),
                () => Validation.validateLatin(params.content_en),
                () => Validation.validateMaxLength(params.content_en, 300),
            ];
        }

        if (!eventInfo.free_live_stream && checkLimit === '1') {
            validateRules.limit = [
                () => Validation.isNotEmpty(params.limit),
                () => Validation.isInt(params.limit),
                () => Validation.isNumberNotZero(params.limit),
            ];
        }
        if (!eventInfo.free_live_stream && checkCost === '1' && eventInfo.has_shopping_cart) {
            validateRules.cost = [
                () => Validation.isNotEmpty(params.cost),
                () => Validation.isInt(params.cost),
                () => Validation.isNumberNotZero(params.cost),
            ];
        }

        const validateResult = Validation.validateAllRules(validateRules);
        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const handleSubmit = () => {
        if (validate() && !errorsUpload) {
            setIsOpenDialogConfirm(true);
        }
    };

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    const handleSubmitData = () => {
        setIsOpenDialogConfirm(false);
        let dataSb = {
            event_name: eventName,
            live_stream_id: liveStreamId,
            data: {
                streamer_profile: checkUndefined(params.streamer_profile),
                content: checkUndefined(params.content),
                document_link: checkUndefined(params.document_link),
                survey_link: checkUndefined(params.survey_link),
                inquiry: checkUndefined(params.inquiry),
                limit: -1,
            },
        };
        if (!eventInfo.free_live_stream && eventInfo.has_shopping_cart) {
            dataSb = {
                ...dataSb,
                data: {
                    ...dataSb.data,
                    limit: +params.limit ? +params.limit : -1,
                },
            };
        }
        if (!eventInfo.free_live_stream && detailEvent && !detailEvent.cost && eventInfo.has_shopping_cart) {
            dataSb = {
                ...dataSb,
                data: {
                    ...dataSb.data,
                    cost: +params.cost,
                },
            };
        }
        if (changeDataUpLoad.changeDocument) {
            dataSb = {
                ...dataSb,
                data: {
                    ...dataSb.data,
                    document: (changeDataUpLoad.changeDocument && params.document) || '',
                },
            };
        }
        if (!_.isEmpty(eventInfo.languages)) {
            dataSb = {
                ...dataSb,
                data: {
                    ...dataSb.data,
                    content_en: checkUndefined(params.content_en),
                    title_en: checkUndefined(params.title_en),
                    speaker_en: checkUndefined(params.speaker_en),
                },
            };
        }
        setChangeDataUpLoad({ changeDocument: false });
        updateDetailLiveStream(dataSb);
    };

    const handleUploadDocument = (file) => {
        setErrorUpload(false);
        handleSetParams('document', file);
        setChangeDataUpLoad({ changeDocument: true });
    };

    const handleCloseDialog = () => {
        handleIsClose();
        setValidateResults({});
        setChangeDataUpLoad({ changeDocument: false });
    };

    const contentConfirm = () => (
        <>
            <CustomTypography>
                内容を保存します。よろしいですか？
            </CustomTypography>
            {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                <>
                    <CustomTypography>
                        ※料金は一度登録すると変更できません。
                    </CustomTypography>
                    <CustomTypography>
                        ご注意ください
                    </CustomTypography>
                </>
            )}
        </>
    );

    const titleConfirm = () => (
        <CustomTypography bold variant="h5">
            <FormattedMessage id="dialog.confirm" />
        </CustomTypography>
    );

    const handleChangeNumber = (field, value) => {
        if (field === 'limit') {
            setCheckLimit(value);
            if (!+value) {
                handleSetParams(field, 0);
            }
        }
        if (field === 'cost') {
            setCheckCost(value);
            if (!+value) {
                handleSetParams(field, 0);
            }
        }
    };

    return (
        <>
            <FormDialog
                title={(
                    <Box>
                        <CustomTypography variant="h6" bold color="info">
                            {customText?.content?.screen_name?.livestream_info_edit || 'ライブ配信情報編集'}
                        </CustomTypography>
                    </Box>
                )}
                isOpen={isOpen}
                handleClose={handleCloseDialog}
                actions={actionsButton()}
            >
                <WrapperContainer className={classes.wrapper}>
                    <GridItem xs={12} md={12}>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    {!_.isEmpty(eventInfo.languages)
                                        ? `${customText?.content?.field_name?.title || 'タイトル'}（和文）`
                                        : (customText?.content?.field_name?.title || 'タイトル')}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9}>
                                <CustomTypography bold>
                                    {params.title}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.spacing}>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold required>
                                        {`${customText?.content?.field_name?.title || 'タイトル'}（英文）`}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9}>
                                    <CleanableInput
                                        defaultValue={params.title_en}
                                        onChange={(valueInput) => handleSetParams('title_en', valueInput)}
                                        error={!!validateResults.title_en}
                                        helperText={validateResults.title_en
                                            ? intl.formatMessage(
                                                { id: validateResults.title_en.message },
                                                { maxLength: 500 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        )}
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    {!_.isEmpty(eventInfo.languages)
                                        ? `${customText?.content?.field_name?.performer || '出演者'}（和文）`
                                        : (customText?.content?.field_name?.performer || '出演者')}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9}>
                                <CustomTypography bold>
                                    {params.speaker}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.spacing}>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold required>
                                        {`${customText?.content?.field_name?.performer || '出演者'}（英文）`}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9}>
                                    <CustomTypography bold>
                                        <CleanableInput
                                            defaultValue={params.speaker_en}
                                            onChange={(valueInput) => handleSetParams('speaker_en', valueInput)}
                                            error={!!validateResults.speaker_en}
                                            helperText={validateResults.speaker_en
                                                ? intl.formatMessage(
                                                    { id: validateResults.speaker_en.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        )}

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    {customText?.content?.field_name?.dates || '日程'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9}>
                                {
                                    (params.dates || []).map((date, index) => (
                                        <CustomTypography bold key={+index}>
                                            {[date.date.slice(0, 4), '/', date.date.slice(5, 7), '/', date.date.slice(8, 10)].join('')}
                                        </CustomTypography>
                                    ))
                                }
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    {customText?.content?.field_name?.time_zone || '時間帯'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9}>
                                <CustomTypography bold>
                                    {`${params.stime} ~ ${params.etime}`}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>

                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold>
                                        {customText?.content?.field_name?.performer_profile || '出演者プロフィール'}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9}>
                                    <CleanableInput
                                        defaultValue={params.streamer_profile}
                                        onChange={(valueInput) => handleSetParams('streamer_profile', valueInput)}
                                        isMultiline
                                        row="3"
                                        error={!!validateResults.streamer_profile}
                                        helperText={validateResults.streamer_profile
                                            ? intl.formatMessage(
                                                { id: validateResults.streamer_profile.message },
                                                { maxLength: 300 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold required>
                                        {!_.isEmpty(eventInfo.languages)
                                            ? `${customText?.content?.field_name?.contents || '配信内容'}（和文）`
                                            : (customText?.content?.field_name?.contents || '配信内容')}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9}>
                                    <CleanableInput
                                        defaultValue={params.content}
                                        onChange={(valueInput) => handleSetParams('content', valueInput)}
                                        isMultiline
                                        row="3"
                                        error={!!validateResults.content}
                                        helperText={validateResults.content
                                            ? intl.formatMessage(
                                                { id: validateResults.content.message },
                                                { maxLength: 300 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        {!_.isEmpty(eventInfo.languages) && (
                            <GridItem className={classes.spacing}>
                                <GridContainer>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography bold required>
                                            {`${customText?.content?.field_name?.contents || '配信内容'}（英文）`}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={9}>
                                        <CleanableInput
                                            defaultValue={params.content_en}
                                            onChange={(valueInput) => handleSetParams('content_en', valueInput)}
                                            isMultiline
                                            row="3"
                                            error={!!validateResults.content_en}
                                            helperText={validateResults.content_en
                                                ? intl.formatMessage(
                                                    { id: validateResults.content_en.message },
                                                    { maxLength: 300 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        )}

                        {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                            <GridContainer className={classes.spacing} style={{ alignItems: 'center' }}>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold required>
                                        {customText?.content?.field_name?.maximum_number_applicants || '申込最大人数'}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={5}>
                                    <RadioGroup
                                        aria-label="limit"
                                        name="limit"
                                        value={checkLimit === '1'}
                                        onChange={(e) => handleChangeNumber('limit', e.target.value)}
                                        row
                                    >
                                        <FormControlLabel
                                            value={hasLimit.no}
                                            control={<Radio color="primary" checked={checkLimit === '0'} />}
                                            label="なし"
                                            className={classes.radioButton}
                                        />
                                        <FormControlLabel
                                            value={hasLimit.yes}
                                            control={<Radio color="primary" checked={checkLimit === '1'} />}
                                            label="あり"
                                            className={classes.radioButton}
                                        />
                                    </RadioGroup>
                                </GridItem>
                            </GridContainer>
                        )}
                        {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                            <GridContainer>
                                <GridItem xs={12} md={3} />
                                <GridItem xs={12} md={3}>
                                    <InputHasUnit
                                        disabled={checkLimit === '0'}
                                        defaultValue={`${params.limit}`}
                                        onChange={(valueInput) => handleSetParams('limit', valueInput)}
                                        error={!!validateResults.limit}
                                        helperText={validateResults.limit
                                            ? intl.formatMessage(
                                                { id: validateResults.limit.message },
                                            ) : ''}
                                        unit="人"
                                        minValue={0}
                                        maxValue={1000000}
                                    />
                                </GridItem>
                            </GridContainer>
                        )}

                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold>
                                        {customText?.content?.field_name?.information || '資料'}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9}>
                                    <UploadButton
                                        text=""
                                        type="document"
                                        onChange={(file) => handleUploadDocument(file)}
                                        namePreview={params.documentPreview}
                                        errors={(value) => setErrorUpload(value)}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>

                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold>
                                        {customText?.content?.field_name?.document_request_reception || '資料請求受付'}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9}>
                                    <CleanableInput
                                        defaultValue={params.document_link}
                                        onChange={(valueInput) => handleSetParams('document_link', valueInput)}
                                        error={!!validateResults.document_link}
                                        helperText={validateResults.document_link
                                            ? intl.formatMessage(
                                                { id: validateResults.document_link.message },
                                                { maxLength: 500 },
                                            ) : ''}
                                    />
                                    <CustomTypography>
                                        ＊ＵＲＬを入力してください。
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        </GridItem>

                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold>
                                        {customText?.content?.field_name?.questionnaire || 'アンケート'}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9}>
                                    <CleanableInput
                                        defaultValue={params.survey_link}
                                        onChange={(valueInput) => handleSetParams('survey_link', valueInput)}
                                        error={!!validateResults.survey_link}
                                        helperText={validateResults.survey_link
                                            ? intl.formatMessage(
                                                { id: validateResults.survey_link.message },
                                                { maxLength: 500 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>

                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3} bold>
                                    <CustomTypography bold>
                                        {customText?.content?.field_name?.inquiries || 'お問合せ'}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9}>
                                    <CleanableInput
                                        defaultValue={params.inquiry}
                                        onChange={(valueInput) => handleSetParams('inquiry', valueInput)}
                                        error={!!validateResults.inquiry}
                                        helperText={validateResults.inquiry
                                            ? intl.formatMessage(
                                                { id: validateResults.inquiry.message },
                                                { maxLength: 500 },
                                            ) : ''}
                                    />
                                    <CustomTypography>
                                        ＊メールアドレスを入力してください。
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        </GridItem>

                        {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                            <GridContainer style={{ alignItems: 'center' }}>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography bold required>
                                        {customText?.content?.field_name?.fee || '料金'}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={5}>
                                    <RadioGroup
                                        aria-label="cost"
                                        name="cost"
                                        value={checkCost === '1'}
                                        onChange={(e) => handleChangeNumber('cost', e.target.value)}
                                        row
                                    >
                                        <FormControlLabel
                                            value={hasCost.no}
                                            control={<Radio color="primary" checked={checkCost === '0'} disabled={params.cost && detailEvent && detailEvent.cost} />}
                                            label="無料"
                                            className={classes.radioButton}
                                        />
                                        <FormControlLabel
                                            value={hasCost.yes}
                                            control={<Radio color="primary" checked={checkCost === '1'} disabled={params.cost && detailEvent && detailEvent.cost} />}
                                            label="有料"
                                            className={classes.radioButton}
                                        />
                                    </RadioGroup>
                                </GridItem>
                            </GridContainer>
                        )}

                        {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                            <GridItem className={classes.spacing}>
                                <GridContainer>
                                    <GridItem xs={12} md={3} />
                                    <GridItem xs={12} md={9} style={{ padding: '0px' }}>
                                        <GridContainer>
                                            <GridItem className={!(+detailEvent.cost) ? classes.rightInput : classes.rightInputDisable}>
                                                <InputHasUnit
                                                    disabled={checkCost === '0'}
                                                    defaultValue={+params.cost}
                                                    className={classes.numberInput}
                                                    onChange={(valueInput) => handleSetParams('cost', valueInput)}
                                                    unit="円"
                                                    minValue={0}
                                                    error={!!validateResults.cost}
                                                    helperText={validateResults.cost
                                                        ? intl.formatMessage(
                                                            { id: validateResults.cost.message },
                                                        ) : ''}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        )}
                    </GridItem>
                </WrapperContainer>
            </FormDialog>
            <Loader isLoading={isLoading} />
            <SnackBar
                open={isOpenSnackBar}
                onClose={() => setIsOpenSnackBar(false)}
                message={messageAction}
                severity="success"
                autoHideDuration={3000}
            />
            <AlertDialog
                title={titleConfirm()}
                handleClose={() => setIsOpenDialogConfirm(false)}
                handleOpen={isOpenDialogConfirm}
                handleSubmit={handleSubmitData}
                contents={contentConfirm()}
            />
        </>
    );
};

DialogEditLiveStreamOrganizer.defaultProps = {
    isOpen: false,
    liveStreamId: null,
    detailEvent: { },
    eventName: '',
    updateSuccess: false,
    eventInfo: {},
};

DialogEditLiveStreamOrganizer.propTypes = {
    isOpen: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    updateSuccess: PropTypes.bool,
    liveStreamId: PropTypes.number,
    handleIsClose: PropTypes.func.isRequired,
    fetchGetDetailLiveStream: PropTypes.func.isRequired,
    fetchClearUpdateLiveStream: PropTypes.func.isRequired,
    detailEvent: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventName: PropTypes.string,
    updateDetailLiveStream: PropTypes.func.isRequired,
    fetchClearDetailLiveStream: PropTypes.func.isRequired,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default DialogEditLiveStreamOrganizer;
